if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

    onSubmitHandler(evt) {
  evt.preventDefault();

  if (
    this.submitButton.getAttribute('aria-disabled') === 'true'
  ) return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const formData = new FormData(this.form);

  /*
   * BEDDER WHITE GLOVE
   *
   * Look only inside this product's information area.
   * This prevents another product/quick-add from interfering.
   */
  const productInfo =
    this.closest('.product__info-container') ||
    this.closest('.product') ||
    document;

  const whiteGloveCheckbox =
  document.querySelector(
    '.bedder-wg-card [data-wg-select]:checked'
  );

const whiteGloveCard =
  whiteGloveCheckbox
    ? whiteGloveCheckbox.closest('.bedder-wg-card')
    : null;

const whiteGloveVariantId =
  whiteGloveCard
    ? Number(
        whiteGloveCard.dataset.whiteGloveVariantId
      )
    : 0;
    const bedderProtectCard =
  document.querySelector(
    '.bedder-protect-card[data-bedder-protect-selected="true"]'
  );

const bedderProtectVariantId =
  bedderProtectCard
    ? Number(
        bedderProtectCard.dataset.bedderProtectVariantId
      )
    : 0;
console.log(
  'BEDDER WHITE GLOVE:',
  {
    checkboxChecked: !!whiteGloveCheckbox,
    cardFound: !!whiteGloveCard,
    selected:
      whiteGloveCard?.dataset.whiteGloveSelected,
    variantId:
      whiteGloveCard?.dataset.whiteGloveVariantId,
    whiteGloveVariantId
  }
);

  /*
   * ----------------------------------------------------
   * NORMAL SHOPIFY ADD TO CART
   * ----------------------------------------------------
   *
   * If White Glove is NOT selected, preserve the
   * original Refresh 15.2 behavior exactly.
   */
  if (
  !whiteGloveVariantId &&
  !bedderProtectVariantId
) {

    const config = fetchConfig('javascript');

    config.headers['X-Requested-With'] =
      'XMLHttpRequest';

    delete config.headers['Content-Type'];

    if (this.cart) {

      formData.append(
        'sections',
        this.cart
          .getSectionsToRender()
          .map((section) => section.id)
      );

      formData.append(
        'sections_url',
        window.location.pathname
      );

      this.cart.setActiveElement(
        document.activeElement
      );
    }

    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)

      .then((response) => response.json())

      .then((response) => {

        if (response.status) {

          publish(
            PUB_SUB_EVENTS.cartError,
            {
              source: 'product-form',
              productVariantId:
                formData.get('id'),
              errors:
                response.errors ||
                response.description,
              message:
                response.message,
            }
          );

          this.handleErrorMessage(
            response.description
          );

          const soldOutMessage =
            this.submitButton.querySelector(
              '.sold-out-message'
            );

          if (!soldOutMessage) return;

          this.submitButton.setAttribute(
            'aria-disabled',
            true
          );

          this.submitButtonText.classList.add(
            'hidden'
          );

          soldOutMessage.classList.remove(
            'hidden'
          );

          this.error = true;

          return;

        } else if (!this.cart) {

          window.location =
            window.routes.cart_url;

          return;
        }

        if (!this.error) {

          publish(
            PUB_SUB_EVENTS.cartUpdate,
            {
              source: 'product-form',
              productVariantId:
                formData.get('id'),
              cartData: response,
            }
          );
        }

        this.error = false;

        const quickAddModal =
          this.closest('quick-add-modal');

        if (quickAddModal) {

          document.body.addEventListener(
            'modalClosed',
            () => {

              setTimeout(() => {
                this.cart.renderContents(
                  response
                );
              });

            },
            { once: true }
          );

          quickAddModal.hide(true);

        } else {

          this.cart.renderContents(
            response
          );

        }

      })

      .catch((e) => {
        console.error(e);
      })

      .finally(() => {

        this.submitButton.classList.remove(
          'loading'
        );

        if (
          this.cart &&
          this.cart.classList.contains(
            'is-empty'
          )
        ) {
          this.cart.classList.remove(
            'is-empty'
          );
        }

        if (!this.error) {
          this.submitButton.removeAttribute(
            'aria-disabled'
          );
        }

        this.querySelector(
          '.loading__spinner'
        ).classList.add('hidden');

      });

    return;
  }


  /*
   * ----------------------------------------------------
   * PRODUCT + WHITE GLOVE
   * ----------------------------------------------------
   */

  const mainVariantId =
    Number(formData.get('id'));

  const quantity =
    Math.max(
      1,
      Number(
        formData.get('quantity') || 1
      )
    );


  const mainItem = {
    id: mainVariantId,
    quantity: quantity
  };


  /*
   * Preserve any Shopify line-item properties
   * already attached to the main product.
   */
  const mainProperties = {};

  for (
    const [key, value] of formData.entries()
  ) {

    if (
      key.startsWith('properties[') &&
      value !== ''
    ) {

      const propertyName =
        key
          .replace('properties[', '')
          .replace(']', '');

      mainProperties[propertyName] =
        value;

    }

  }

  if (
    Object.keys(mainProperties).length
  ) {
    mainItem.properties =
      mainProperties;
  }


  /*
   * Preserve selling plan if a product ever uses one.
   */
  const sellingPlan =
    formData.get('selling_plan');

  if (sellingPlan) {
    mainItem.selling_plan =
      sellingPlan;
  }


  /*
   * Try to capture the product name for the
   * White Glove cart-line association.
   */
  const productTitleElement =
    productInfo.querySelector(
      '.product__title h1, .product__title'
    );

  const productTitle =
    productTitleElement
      ? productTitleElement.textContent.trim()
      : 'Product';


  const items = [
  mainItem
];


if (whiteGloveVariantId) {

  items.push({
    id: whiteGloveVariantId,
    quantity: 1,

    properties: {
      'White Glove Service For':
        productTitle
    }
  });

}


if (bedderProtectVariantId) {

  items.push({
    id: bedderProtectVariantId,
    quantity: 1,

    properties: {
      'BedderProtect Plan For':
        productTitle
    }
  });

}


  const body = {
    items: items
  };


  if (this.cart) {

    body.sections =
      this.cart
        .getSectionsToRender()
        .map((section) => section.id);

    body.sections_url =
      window.location.pathname;

    this.cart.setActiveElement(
      document.activeElement
    );
  }


  const config = fetchConfig('javascript');

  config.headers['X-Requested-With'] =
    'XMLHttpRequest';

  config.headers['Content-Type'] =
    'application/json';

  config.body =
    JSON.stringify(body);


  fetch(`${routes.cart_add_url}`, config)

    .then((response) => response.json())

    .then((response) => {

      if (response.status) {

        publish(
          PUB_SUB_EVENTS.cartError,
          {
            source: 'product-form',
            productVariantId:
              mainVariantId,
            errors:
              response.errors ||
              response.description,
            message:
              response.message,
          }
        );

        this.handleErrorMessage(
          response.description
        );

        this.error = true;

        return;
      }


      if (!this.cart) {

        window.location =
          window.routes.cart_url;

        return;
      }


      publish(
        PUB_SUB_EVENTS.cartUpdate,
        {
          source: 'product-form',
          productVariantId:
            mainVariantId,
          cartData:
            response,
        }
      );


      this.error = false;


      const quickAddModal =
        this.closest(
          'quick-add-modal'
        );


      if (quickAddModal) {

        document.body.addEventListener(
          'modalClosed',
          () => {

            setTimeout(() => {

              this.cart.renderContents(
                response
              );

            });

          },
          { once: true }
        );

        quickAddModal.hide(true);

      } else {

        this.cart.renderContents(
          response
        );

      }

    })

    .catch((error) => {

      console.error(
        'Bedder White Glove Add Error:',
        error
      );

      this.handleErrorMessage(
        'We could not add your selection. Please try again.'
      );

      this.error = true;

    })

    .finally(() => {

      this.submitButton.classList.remove(
        'loading'
      );


      if (
        this.cart &&
        this.cart.classList.contains(
          'is-empty'
        )
      ) {

        this.cart.classList.remove(
          'is-empty'
        );

      }


      if (!this.error) {

        this.submitButton.removeAttribute(
          'aria-disabled'
        );

      }


      this.querySelector(
        '.loading__spinner'
      ).classList.add(
        'hidden'
      );

    });
}

      

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
